export const getAllCartItems = (state) => state.cart;
export const getCartItemCount = (state) => state.cart.length;